import { useState } from 'react';

export default function MaintenancePopup({ isOpen, heading, SheduledProcessDateTime, onClose }) {
    const [selectedDate, setSelectedDate] = useState(null);
    const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
    const [time, setTime] = useState({ hour: '10', minute: '00', period: 'AM' });
    const [error, setError] = useState('');
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [actionsHeading, setActionsHeading] = useState('');
    const [actionType, setActionType] = useState('');

    const today = new Date();
    const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();




 const ConfimDate = `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-${String(selectedDate).padStart(2, '0')} ${time.hour}:${time.minute} ${time.period} `


    const convertTo24HourFormat = ({ hour, minute, period }) => {
        const convertedHour = period === 'PM' && hour !== '12' ? +hour + 12 : period === 'AM' && hour === '12' ? 0 : hour;
        return `${String(convertedHour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
    };

    const scheduledTime = convertTo24HourFormat(time);
    const scheduledDateTime = `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-${String(selectedDate).padStart(2, '0')} ${scheduledTime}`;

    const resetState = () => {
        setSelectedDate(null);
        setCurrentMonth(new Date().getMonth());
        setCurrentYear(new Date().getFullYear());
        setTime({ hour: '10', minute: '00', period: 'AM' });
        setError('');
        setShowConfirmation(false);
    };

    const handleDateClick = (day) => {
        const selected = new Date(currentYear, currentMonth, day);
        if (selected >= today) {
            setSelectedDate(day);
            setError('');
        } else {
            setError('Cannot select past dates');
        }
    };

    const handleMonthChange = (direction) => {
        setSelectedDate(null);
        setError('');
        if (direction === 'next') {
            setCurrentMonth((prev) => (prev + 1) % 12);
            if (currentMonth === 11) setCurrentYear((prev) => prev + 1);
        } else {
            setCurrentMonth((prev) => (prev - 1 + 12) % 12);
            if (currentMonth === 0) setCurrentYear((prev) => prev - 1);
        }
    };

    const handleTimeChange = (e, type) => {
        if (!selectedDate) {
            setError('Please select a date first');
            return;
        }
        setError('');
        setTime((prev) => ({ ...prev, [type]: e.target.value }));
    };

    const handleActionClick = (action) => {
        if (action === 'schedule' && !selectedDate) {
            setError('Please select a date first');
            return;
        }

        const actionHeading = action === 'schedule'
            ? `Schedule Maintenance at ${ConfimDate}`
            : 'Run Maintenance';

        setActionType(action);
        setActionsHeading(actionHeading);
        setShowAlert(true);
        setShowConfirmation(true);
    };

    const handleConfirmAction = () => {
        setShowConfirmation(false);
        SheduledProcessDateTime(scheduledDateTime, actionType);
        onClose();
    };

    return (
        <section
            className={`absolute inset-0 pb-40 z-50 flex items-center justify-center backdrop-blur-sm ${!isOpen && 'hidden'}`}
        >
            <div className={`w-[29.25rem] p-6 bg-SoftBlack text-white rounded-lg ${showConfirmation && 'hidden'}`}>
                <div className="flex justify-between mb-4">
                    <h2 className="text-lg font-bold">Schedule {heading}</h2>
                    <button onClick={onClose} className="w-6 h-6">
                        <img src="/Icons/close.svg" alt="close" title="close" />
                    </button>
                </div>

                <label className="text-sm mb-2 block">Select date</label>
                <div className="flex items-center justify-between mb-4">
                    <button onClick={() => handleMonthChange('prev')}>&lt;</button>
                    <span className="font-semibold">
                        {new Date(currentYear, currentMonth).toLocaleString('default', { month: 'long', year: 'numeric' })}
                    </span>
                    <button onClick={() => handleMonthChange('next')}>&gt;</button>
                </div>

                <div className="grid grid-cols-7 text-center mb-4">
                    {['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'].map((day) => (
                        <div key={day} className="text-sm text-gray-400">{day}</div>
                    ))}
                    {Array.from({ length: daysInMonth }).map((_, i) => {
                        const day = i + 1;
                        const isPast = new Date(currentYear, currentMonth, day) < today;
                        return (
                            <button
                                key={i}
                                onClick={() => handleDateClick(day)}
                                className={`w-8 h-8 flex items-center justify-center rounded-full ${selectedDate === day
                                    ? 'bg-red-500 text-white'
                                    : isPast
                                        ? 'text-gray-500 cursor-not-allowed'
                                        : 'text-gray-300 hover:bg-gray-600'}`}
                                disabled={isPast}
                            >
                                {day}
                            </button>
                        );
                    })}
                </div>

                <label className="text-sm mb-2 block">Select time</label>
                <div className="flex items-center mb-4">
                    <select value={time.hour} onChange={(e) => handleTimeChange(e, 'hour')} className="bg-gray-700 p-2 rounded mr-2">
                        {Array.from({ length: 12 }).map((_, i) => (
                            <option key={i} value={i + 1}>{i + 1}</option>
                        ))}
                    </select>
                    <span className="text-white">:</span>
                    <select value={time.minute} onChange={(e) => handleTimeChange(e, 'minute')} className="bg-gray-700 p-2 rounded mx-2">
                        {['00', '15', '30', '45'].map((val) => (
                            <option key={val} value={val}>{val}</option>
                        ))}
                    </select>
                    <select value={time.period} onChange={(e) => handleTimeChange(e, 'period')} className="bg-gray-700 p-2 rounded ml-2">
                        {['AM', 'PM'].map((val) => (
                            <option key={val} value={val}>{val}</option>
                        ))}
                    </select>
                </div>

                {error && <div className="text-red-500 text-sm mb-4">{error}</div>}

                <button onClick={() => handleActionClick('schedule')} className="bg-red-500 py-2 px-4 rounded w-full mb-2">
                    Schedule
                </button>
                <div className="text-center text-gray-300 mb-2">or</div>
                <button onClick={() => handleActionClick('run')} className="bg-red-500 py-2 px-4 rounded w-full">
                    Run now
                </button>
            </div>

            {showConfirmation && (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
                    <div className="bg-gray-800 rounded-lg p-6 text-center">
                        <h2 className="text-white text-lg font-semibold mb-6">
                            Do you want to {actionsHeading}?
                        </h2>
                        <div className="flex justify-center space-x-4">
                            <button onClick={() => setShowConfirmation(false)} className="bg-gray-300 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-400">
                                Cancel
                            </button>
                            <button onClick={handleConfirmAction} className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700">
                                Yes
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
}
